/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type BucketModeEnum = 'INDIVIDUAL' | 'SHARED';

export const BucketModeEnum = {

    INDIVIDUAL: 'INDIVIDUAL' as BucketModeEnum,

    SHARED: 'SHARED' as BucketModeEnum
};

